import { useEffect, useRef, useState } from "react";

export default function useResizableColumns({
  initial = 50,
  min = 20,
  max = 80,
}) {
  const [leftWidth, setLeftWidth] = useState(initial);
  const containerRef = useRef(null);
  const isResizing = useRef(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing.current || !containerRef.current) return;

      const rect = containerRef.current.getBoundingClientRect();
      const percent =
        ((e.clientX - rect.left) / rect.width) * 100;

      const clamped = Math.min(max, Math.max(min, percent));
      setLeftWidth(clamped);
    };

    const handleMouseUp = () => {
      isResizing.current = false;
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [min, max]);

  const startResize = () => {
    isResizing.current = true;
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
  };

  return {
    containerRef,
    leftWidth,
    rightWidth: 100 - leftWidth,
    startResize,
  };
}
